import Image from "next/image";
import { Box, Grid } from "@mui/material";
import { bannerHeight } from "../../utils/bannerHeight";

const Block1 = () => {
  return (
    <Grid container lg={12} className="mb-40 items-center">
      <Grid item xs={12} md={12} lg={12}>
        <img
          src={`${process.env.IMAGE_BASE_URL}/images/about/about.png`}
          alt="image"
          // className="rounded-4"
          style={{ width: "100%", height: bannerHeight() }}
        />
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{ marginTop: '50px' }}>
        <h1 className="text-30 fw-600 text-center">ABOUT US</h1>
        <div className="fleet_content container text-center">
          <p className="text-dark-1">
            Royal Smart Limousine provides top-notch travel services globally. <br /> We
            maintain high standards of quality for your travel experiences.
          </p>
        </div>
      </Grid>
    </Grid>
  );
};

export default Block1;
